import { IMergeTag } from '@beefree.io/sdk/dist/types/bee';
export * from './marketingTemplate';
export * from './customRow';
export * from './EblastBrokersTypeEnum';

export interface IBeeAccountConfig {
  mergeTags: IMergeTag[];
  uid: string;
}

export interface IEditCustomRowData {
  isOpened: boolean;
  row: any;
  resolve: (data: Record<string, unknown>, options?: Record<string, unknown> | undefined) => void
  reject: () => void;
}

export interface ISendTestDialog {
  isOpened: boolean;
  templatePath: string;
}

export enum TemplateTransactionType {
  for_sale = 'for_sale',
  for_lease = 'for_lease',
  sublease = 'sublease',
  investment_sale = 'investment_sale',
}
